<seriesComponentSheetView *ngIf="sheet_ready"  [components]="components" [seriescomponents]="series_components" [process]="process"></seriesComponentSheetView>